<template>
  <section class="t-hero" style="background-image: var(--tkd-gradient-hero), url(/images/banner.jpg)">
    <template v-if="item">
      <div class="hero-top">
        <router-link to="/user/tournaments" class="back-link"><tkd-icon name="arrow-left"/> Усі турніри</router-link>
        <div class="hero-badges">
          <span class="pub-badge" :class="onlyForActivated ? 'act-on' : 'act-off'"
                :title="onlyForActivated ? 'Реєстрація лише для активованих' : 'Реєстрація для всіх'">
            <span class="badge-dot"></span>{{ onlyForActivated ? 'Лише активовані' : 'Для всіх' }}
          </span>
          <span class="pub-badge" v-if="showDraws !== null" :class="showDraws ? 'pub-on' : 'act-off'"
                :title="showDraws ? 'Жеребкування показується' : 'Жеребкування не показується'">
            <span class="badge-dot"></span>{{ showDraws ? 'Жеребкування видно' : 'Жеребкування приховано' }}
          </span>
          <span class="pub-badge" :class="item.published == 1 ? 'pub-on' : 'pub-off'" title="Публікувати (Telegram бот)">
            <span class="badge-dot"></span>{{ item.published == 1 ? 'Опубліковано' : 'Не опубліковано' }} в Telegram
          </span>
        </div>
      </div>

      <div class="hero-main">
        <div class="hero-title">
          <span class="hero-id">Турнір #{{ item.id }}</span>
          <h1>{{ item.name || 'Назву не вказано' }}</h1>
        </div>
        <button type="button" class="edit-btn" @click="updateTournament(item.id)"><tkd-icon name="edit"/> Редагувати</button>
      </div>

      <div class="hero-meta">
        <div class="meta-chip" v-for="meta in metaList" :key="meta.label">
          <span class="meta-icon"><tkd-icon :name="meta.icon"/></span>
          <span class="meta-text">
            <small>{{ meta.label }}</small>
            <span :class="{ missing: !meta.value }">{{ meta.value || 'не вказано' }}</span>
          </span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="skeleton sk-back"></div>
      <div class="skeleton sk-title"></div>
      <div class="hero-meta">
        <div class="skeleton sk-chip" v-for="n in 4" :key="n"></div>
      </div>
    </template>
    <div class="hero-flag"><span></span><span></span></div>
  </section>
</template>

<script>
  import 'src/assets/css/tkd-theme.css';

  export default {
    name: "info-navbar",

    computed: {
      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      item() {
        return this.tournamentOne && this.tournamentOne.data ? this.tournamentOne.data.item : null;
      },
      // only_for_activated може прийти як 1/'1'/true
      onlyForActivated() {
        return this.isFlagOn(this.item && this.item.only_for_activated);
      },
      // як у формі: show_draws, старе поле — show_draw; null — API не повернув поле
      showDraws() {
        if (!this.item) return null;
        const isEmpty = v => v === undefined || v === null || v === '';
        const value = isEmpty(this.item.show_draws) ? this.item.show_draw : this.item.show_draws;
        return isEmpty(value) ? null : this.isFlagOn(value);
      },
      metaList() {
        return [
          { icon: 'calendar', label: 'Дата', value: this.item.date },
          { icon: 'location', label: 'Місто', value: this.item.city },
          { icon: 'arena', label: 'Адреса', value: this.item.address },
          { icon: 'phone', label: 'Контакти', value: this.item.contacts },
          { icon: 'referee', label: 'Головний суддя', value: this.item.judgename },
          { icon: 'referee', label: 'Суддя', value: this.item.judgename2 },
          { icon: 'notes', label: 'Секретар', value: this.item.secretaryname },
        ];
      }
    },
    methods: {
      isFlagOn(value) {
        return value === true || value === 'true' || Number(value) === 1;
      },
      updateTournament(id) {
        this.$router.replace({path: `/user/tournaments/update/${id}`})
      },
    }
  }
</script>

<style scoped>
  .t-hero {
    position: relative;
    overflow: hidden;
    padding: 24px 32px 28px;
    border-radius: var(--tkd-radius-lg);
    background-color: var(--tkd-navy);
    background-position: center;
    background-size: cover;
    box-shadow: 0 20px 50px rgba(10, 31, 68, 0.25);
    font-family: var(--tkd-font);
    color: #fff;
  }

  .hero-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
  }

  .back-link {
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
  }

  .back-link:hover { color: #fff; text-decoration: none; }

  .pub-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .pub-on { color: #6ce9a6; background: rgba(18, 183, 106, 0.15); border: 1px solid rgba(108, 233, 166, 0.4); }
  .pub-off { color: #fda29b; background: rgba(240, 68, 56, 0.15); border: 1px solid rgba(253, 162, 155, 0.4); }
  .act-on { color: var(--tkd-yellow); background: rgba(255, 213, 0, 0.12); border: 1px solid rgba(255, 213, 0, 0.45); }
  .act-off { color: rgba(255, 255, 255, 0.75); background: rgba(255, 255, 255, 0.08); border: 1px solid rgba(255, 255, 255, 0.25); }
  .hero-badges { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 8px; }
  .badge-dot { width: 8px; height: 8px; border-radius: 50%; background: currentColor; }

  .hero-main {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px 24px;
    flex-wrap: wrap;
  }

  .hero-title { min-width: 0; flex: 1 1 400px; }

  .hero-id {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--tkd-yellow);
  }

  .hero-title h1 {
    margin: 6px 0 0;
    font-size: 30px;
    line-height: 1.2;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: #fff;
    overflow-wrap: anywhere;
  }

  .edit-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 46px;
    padding: 0 20px;
    border: 0;
    border-radius: var(--tkd-radius);
    font-size: 15px;
    font-weight: 700;
    color: var(--tkd-navy);
    background: var(--tkd-yellow);
    box-shadow: 0 10px 24px rgba(255, 213, 0, 0.25);
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.2s;
  }

  .edit-btn:hover { transform: translateY(-1px); box-shadow: 0 14px 30px rgba(255, 213, 0, 0.35); }
  .edit-btn:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }

  .hero-meta {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    margin-top: 20px;
  }

  .meta-chip {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    padding: 10px 14px;
    border-radius: var(--tkd-radius);
    background: rgba(255, 255, 255, 0.07);
    border: 1px solid rgba(255, 255, 255, 0.12);
  }

  .meta-icon { font-size: 18px; flex-shrink: 0; }
  .meta-text { display: flex; flex-direction: column; min-width: 0; line-height: 1.3; }
  .meta-text small { font-size: 11px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: rgba(255, 255, 255, 0.55); }
  .meta-text span { font-size: 14px; font-weight: 600; overflow-wrap: anywhere; }
  .missing { color: #fda29b; font-style: italic; font-weight: 400 !important; }

  .hero-flag {
    position: absolute;
    left: 32px;
    bottom: 0;
    display: flex;
    width: 64px;
    height: 5px;
    border-radius: 3px 3px 0 0;
    overflow: hidden;
  }
  .hero-flag span { flex: 1; background: var(--tkd-blue); }
  .hero-flag span + span { background: var(--tkd-yellow); }

  .skeleton {
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.22) 50%, rgba(255, 255, 255, 0.1) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
  }
  .sk-back { width: 110px; height: 16px; margin-bottom: 18px; }
  .sk-title { width: 55%; height: 34px; }
  .sk-chip { height: 54px; border-radius: var(--tkd-radius); }

  @keyframes shimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }

  @media (max-width: 767px) {
    .t-hero { padding: 20px 18px 24px; }
    .hero-title h1 { font-size: 24px; }
    .edit-btn { width: 100%; justify-content: center; }
    .hero-flag { left: 18px; }
  }

  @media (prefers-reduced-motion: reduce) {
    .skeleton { animation: none; }
  }
</style>
